/**
 * Created by alvinoktavianus on 5/9/17.
 */

import { API_URL } from '../constants';

export const { MOKA_SERVICE_HOST } = process.env;

export const BILLINGS = `${API_URL}/v1/billings`;
export const RULES = `${API_URL}/v1/billings/rules`;
export const SUBSCRIPTION_STATUS = `${API_URL}/v1/feature/get_subscription_status`;
export const VERIFY_BILLING = `${API_URL}/v1/billings/verify`;
export const VERIFY_BILLING_FOR_EXTEND_OUTLET = `${API_URL}/v1/billings/verify_extend_outlet`;
export const FEATURE_SUBSCRIPTION_PRICE = `${MOKA_SERVICE_HOST}/business-service/v1/feature/feature-price-per-months`;
export const CANCEL_SUBSCRIPTION = `${API_URL}/v1/feature/cancel_subscription`;
export const IS_ACTIVE_SUBCRIPTIONS_URL = `${API_URL}/v1/outlet/update_active_subcription`;
export const GET_PRORATE_PRICE = `${API_URL}/v1/billings/prorate_price`;
export const BUSINESS_SUBSCRIPTION = `${MOKA_SERVICE_HOST}/business-subscription`;
